<template>
  <div>
    <div
      class="md-layout"
      v-if="show_carregando != null && show_carregando != undefined && show_carregando == true"
    >
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>Carregando ..
      </div>
    </div>

    <div v-if="items != null && items != undefined  && items.length > 0 " class="checkbox_list">
      <div v-for="(item, index) in items" :key="index">
        <md-checkbox
          v-if="possoMostrarId(item)"
          :key="index"
          v-model="items_selected"
          :value="item.id.toString()"
          :change="seleciona"
        >{{item.nome}}</md-checkbox>
      </div>
    </div>
    <div v-if="show_marcatodos != null && show_marcatodos != undefined && show_marcatodos == '1'">
      <div v-if="items != null && items != undefined  && items.length > 0 ">
        <md-checkbox
          class="md-default"
          v-if="show_marcatodos != null && show_marcatodos != undefined && show_marcatodos "
          :value="true"
          v-model="seleciona_todos"
        >Marcar Todos</md-checkbox>
      </div>
    </div>

    <div v-if="items == null || items == undefined">
      <i>Carregando..</i>
    </div>

    <div
      v-if="items != null && items != undefined  && items.length <= 0 && (show_carregando == null || show_carregando == undefined || show_carregando == false)"
      class="checkbox_list"
    >
      <i>Não há itens</i>
    </div>
  </div>
</template>
<style>
div.checkbox_list {
  max-height: 250px;

  overflow-y: scroll;
  overflow-x: scroll;
  width: 100% !important;
}
</style>

<script>
import Api from "../../library/Api.js";

export default {
  props: [
    "field_value",
    "field_text",
    "search_method",
    "exclude_itens",
    "show_marcatodos",
    "value_marcatodos",
    "onSelect",
    "onMarcaTodos",
    "id_start_value",
    "items",
    "show_carregando",
    "id_not_in"
  ],

  components: {},
  model: {
    prop: "id_start_value",
    event: "selected"
  },
  data() {
    return {
      codigo: "",
      texto: "",
      items_selected: [],
      items_nao_mostrar: [],
      ids_exclude: [],

      show_search: false,
      // show_carregando: false,
      show_add_button: false,
      timeout: null,
      seleciona_todos: false
    };
  },
  mounted() {
    var self = this;

    if (this.id_start_value != null && this.id_start_value != undefined && this.id_start_value.toString() != "") {
      this.items_selected = this.id_start_value.toString().split(",");
    }
  },
  watch: {
    id_start_value: function(val) {
      if (this.id_start_value != null && this.id_start_value != undefined) {
        this.items_selected = this.id_start_value.toString().split(",");
      }
    },
    items_selected: function(val) {
      this.$emit("selected", this.items_selected.join(","));
    },
    value_marcatodos: function(val) {
      if (this.value_marcatodos != null && this.value_marcatodos != undefined) {
        this.seleciona_todos = this.value_marcatodos.toString() == "1";
      }
    },
    id_not_in: function(val) {
      if (
        this.id_not_in != null &&
        this.id_not_in != undefined &&
        this.id_not_in != ""
      ) {
        this.items_nao_mostrar = this.id_not_in.toString().split(",");
      } else {
        this.items_nao_mostrar = [];
      }
    },
    seleciona_todos: function(val) {
      this.fn_seleciona_todos();
    }
  },
  methods: {
    possoMostrarId(item) {
      if (item == null || item == undefined) return false;

      if (this.id_not_in == null) return true;

      if (this.id_not_in == undefined) return true;

      return this.items_nao_mostrar.indexOf(item.id.toString()) < 0; //Se não existe, então eu mostro aqui...
    },

    temEstaId(id) {
      if (this.id_start_value != null && this.id_start_value != undefined) {
        if (this.id_start_value.toString().split(",").indexOf(id.toString()) > -1) {
          return true;
        }
      }

      return false;
    },
    fn_seleciona_todos() {
      console.log("fn_seleciona_todos" + this.seleciona_todos);
      if (this.seleciona_todos) {
        var ar = [];

        for (var i = 0; i < this.items.length; i++) {
          ar[i] = this.items[i][this.field_value];
        }

        this.items_selected = ar;
      } else {
        this.items_selected = [];
      }
    },

    seleciona(ev) {
      var valor = ev.target.value;
      var checked = ev.target.checked;

      if (this.items_selected.indexOf(valor.toString()) > -1) {
        //Já existe.

        if (!checked) {
          //Foi desmarcado..

          this.items_selected.splice(valor, 1);
        }
      } else {
        if (checked) {
          this.items_selected.push(valor);
        }
      }

      console.log("On select?");
      console.log(this.onSelect);
      this.$emit("selected", this.items_selected.join(","));
      if (this.onSelect != null && this.onSelect != undefined) {
        this.onSelect(this.items_selected);
      }
    },
    add() {}
  }
};
</script>